import getMediaQueriesStyling from '@hellodarwin/core/lib/features/helpers/get-media-query-styling';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled, { css } from 'styled-components';
const citationIconColors = {
    purple_1: 'purple_3',
    purple_2: 'purple_3',
    purple_3: 'purple_1',
    purple_4: 'purple_1',
    purple_5: 'purple_1',
    green_1: 'green_3',
    green_2: 'green_3',
    green_3: 'green_1',
    green_4: 'green_1',
    grey_1: 'grey_3',
    grey_2: 'grey_3',
    yellow_1: 'yellow_3',
    yellow_2: 'yellow_3',
    yellow_3: 'yellow_1',
    yellow_4: 'yellow_1',
    beige_1: 'beige_3',
    beige_2: 'beige_3',
    beige_3: 'beige_1',
    beige_4: 'beige_1',
    white_1: 'grey_1',
    grey_3: 'grey_3',
    grey_4: 'grey_3',
    grey_5: 'grey_3',
    transparent: 'grey_1',
};
export const DefaultStyling = (theme, backgroundColor, backgroundAlreadyCompiled) => css `
  padding: 20px;

  background-color: ${backgroundAlreadyCompiled
    ? backgroundColor
    : theme.colors[backgroundColor || 'beige_1']};

  ${media.xl `padding: 16px;`}
  ${media.tablet `padding: 12px;`}
  

  ${media.xl `padding: 16px;`}
  ${media.tablet `padding: 12px;`}
`;
export const AssetCardContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  margin: 0 auto;
  overflow: visible;

  max-height: 100%;

  ${({ $withBorder, theme }) => $withBorder ? `border: 1px solid ${theme.colors.primary};` : ''};
  ${({ $isIcon, $fitContent, theme, $backgroundColor, $backgroundAlreadyCompiled, }) => !$isIcon && !$fitContent
    ? DefaultStyling(theme, $backgroundColor, $backgroundAlreadyCompiled)
    : ''};

  ${({ $align }) => {
    const alignement = {
        start: 'flex-start',
        end: 'flex-end',
        center: 'center',
        stretch: 'stretch',
    }[$align !== null && $align !== void 0 ? $align : 'stretch'];
    return `align-self: ${alignement};`;
}}

  gap: 18px;
  position: relative;

  .citation-icon {
    path {
      fill: ${({ theme, $backgroundColor }) => { var _a; return theme.colors[(_a = citationIconColors[$backgroundColor]) !== null && _a !== void 0 ? _a : 'purple_1']; }};
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  ${(props) => getMediaQueriesStyling(props)}
`;
export const AssetCardDescriptionContainer = styled.div ``;
export const AssetsListContainer = styled.div `
  display: flex;
  gap: 24px;
  ${({ $disposition }) => $disposition === 'Horizontal'
    ? `
      flex-direction:row;
      justify-content:flex-start;
      align-items:stretch;
      `
    : `
      flex-direction:column;
      justify-content:stretch;
      align-items:flex-start;
    `}

  ${({ $hasIcon }) => !$hasIcon
    ? media.md `
    flex-direction:column;
    `
    : ''}
`;
export const InfoTileContainer = styled.div `
  border-radius: ${({ theme }) => theme.border_radius.md};
  background: rgba(43, 43, 43, 0.6);
  backdrop-filter: blur(4px);
  padding: 18px;
  position: absolute;
`;
